import React, { createContext, useContext, useState, useCallback } from 'react';

const ViewContext = createContext({ view: '', setView: () => {} });

export const ViewProvider = ({ children }) => {
  const [view, setViewState] = useState('');
  const setView = useCallback((v) => setViewState(v || ''), []);
  return (
    <ViewContext.Provider value={{ view, setView }}>
      {children}
    </ViewContext.Provider>
  );
};

export const useViewContext = () => useContext(ViewContext);
